module.exports = __webpack_public_path__ + "static/turquia-006.thumb-eaad38f905f16759f1a55c86e136390c.jpg";